module.exports = __webpack_public_path__ + "media/mario-coin.1b03af4c.mp3";